import React from "react";
import { Tabs } from 'antd';
import { AppstoreOutlined, SettingOutlined } from '@ant-design/icons';

export interface TabsConfiguracoesProps {
    activeKey: string;
    onChange: (key: string) => void;
}

export const TabsConfiguracoes: React.FC<TabsConfiguracoesProps> = ({ activeKey, onChange }: TabsConfiguracoesProps) => {
    return (
        <Tabs
            activeKey={activeKey}
            onChange={onChange}
            style={{ marginBottom: 16 }}
            items={[
                {
                    key: 'planos',
                    label: (
                        <span>
                            <AppstoreOutlined /> Configurações de Planos
                        </span>
                    )
                },
                {
                    key: 'geral',
                    label: (
                        <span>
                            <SettingOutlined /> Configurações Gerais
                        </span>
                    )
                }
            ]}
        />
    );
};

export default TabsConfiguracoes;
